<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>Order form</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'narrow'">
    <ng-container
      *ngIf="{
        orderConfirmationItems: orderConfirmationItems$ | async,
        productIsInstantBilledMap: productIsInstantBilledMap$ | async,
        userCanEditBillingInfo: userCanEditBillingInfo$ | async,
        partnerId: partnerId$ | async,
        billingInfoConfigured: billingInfoConfigured$ | async,
        stairstepOrderRequiresBilling: stairstepOrderRequiresBilling$ | async,
        accountGroup: accountGroupId$ | async,
        editionsMap: editionsMap$ | async
      } as orderConfirmationData"
    >
      <app-order-form-apps-custom-price
        *ngIf="!!orderConfirmationData.orderConfirmationItems; else loading"
        [productIsInstantBilledMap]="orderConfirmationData.productIsInstantBilledMap"
        [userCanEditBillingInfo]="orderConfirmationData.userCanEditBillingInfo"
        [partnerId]="orderConfirmationData.partnerId"
        [billingInfoConfigured]="orderConfirmationData.billingInfoConfigured"
        [stairStepOrderRequiresBilling]="orderConfirmationData.stairstepOrderRequiresBilling"
        [accountGroupId]="orderConfirmationData.accountGroup"
        [editionsMap]="orderConfirmationData.editionsMap"
        [orderConfirmationItems]="orderConfirmationData.orderConfirmationItems"
      ></app-order-form-apps-custom-price>
    </ng-container>
    <ng-container *ngIf="form; else spinner">
      <div *ngIf="statusMessages$ | async as statusMessages">
        <div *ngFor="let status of statusMessages" class="banner-container">
          <app-status-banner [statusText]="status.text" [type]="status.type"></app-status-banner>
        </div>
      </div>
      <ng-container *ngIf="orderData$ | async as orderData; else loading">
        <business-product-activation-prereq-form
          *ngIf="productIds$ | async as productIds"
          #productActivationPrereqForm
          [productIds]="productIds"
          [businessId]="accountGroupId$ | async"
          [expanded]="true"
        ></business-product-activation-prereq-form>
        <form (ngSubmit)="onSubmit()" [formGroup]="form">
          <sales-ui-sales-order-form
            #salesOrderForm
            [businessId]="accountGroupId"
            [lineItems]="lineItems$ | async"
            [userOptions]="orderData.users"
            [answers]="orderData.answers"
            [orderFormOptions]="orderData.options"
            [fileUploadUrl]="fileUploadUrl"
            (loading)="updateFormLoadingStatus($event)"
          ></sales-ui-sales-order-form>
          <div class="button-container">
            <button type="button" data-action="back" mat-stroked-button (click)="goBack()">
              {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
            </button>
            <button type="submit" data-action="next" mat-flat-button [disabled]="isFormLoading" color="primary">
              {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
            </button>
          </div>
        </form>
        <div
          *ngIf="someProductHasWorkOrderEnabled$ | async"
          class="work-order-for-chameleon"
          data-action="product-has-work-order-enabled"
        ></div>
      </ng-container>
    </ng-container>

    <ng-template #spinner>
      <mat-spinner [strokeWidth]="4" mode="indeterminate"></mat-spinner>
    </ng-template>
    <ng-template #loading>
      <store-list-stencil></store-list-stencil>
    </ng-template>
  </glxy-page-wrapper>
</glxy-page>
